import React, { FC } from 'react'

import Wrap from 'layout/wrap'
import RoomsPage from 'layout/rooms'

import { message } from 'message/index.ja'

const lang = 'ja'

const Page: FC = () => {
  return (
    <section className={`font--${lang}`}>
      <Wrap message={message}>
        <RoomsPage message={message} lang={lang} />
      </Wrap>
    </section>
  )
}
export default Page
